shadow$provide[394] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `void mapXyzw2DV(vec4 xyzw, out vec2 xy, out float z) {
  xy = xyzw.xy;
  z  = xyzw.z;
}

`;

};